import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-campaign-ended',
  templateUrl: './campaign-ended.component.html',
  styleUrls: ['./campaign-ended.component.scss']
})
export class CampaignEndedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
